<template lang="pug">
  .category-input
    PhoValidationProvider(:name="validationName" :rules="rules")
      PhoAutocomplete(
        v-model="lazyValue"
        attach
        outlined
        item-value="id"
        item-text="displayName"
        :multiple="multiple"
        :items="lazyCategories"
        :label="validationName"
      )
        template(v-slot:selection='{ item }')
          div(:class="item.class" class="v-select__selection v-select__selection--comma list-with-comma") {{ item.displayName }}
</template>
<script>

import { useContext } from '@/compat';
import {
  computed, onMounted, ref, watch,
} from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { useRouter } from '@/helpers/misc/useRouter';
import { filterSelectedValues } from '@/helpers/content';
import { isNullOrEmpty, useSelectedSorter } from '@/helpers/misc';
import { PhoAutocomplete, PhoValidationProvider } from '@/components/misc/form';
import { getCategories } from '@/api/category/CategoryApi';

export default {
  name: 'CategoryInput',
  components: {
    PhoValidationProvider,
    PhoAutocomplete,
  },
  props: {
    value: {
      type: [Array, String],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    mainCategory: {
      type: String,
      default: '',
    },
    listOnlyApprovedCategories: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { $i18n, $lang } = useContext();
    const { lazyValue } = useModelAutoBinding(emit, props, null);
    const allCategories = ref([]);
    const previouslySelectedIds = ref([]);

    const getCategoryTextClass = item => {
      if (!item.isApproved) {
        return 'red--text';
      }

      return '';
    };

    const lazyItems = computed(() => {
      const categoriesToShow = allCategories.value.filter(item => (
        (!props.listOnlyApprovedCategories || item.isApproved)
        && (isNullOrEmpty(props.mainCategory) || item.hierarchy.some(h => h === props.mainCategory))
      ) || previouslySelectedIds.value.some(selectedId => selectedId.id === item.id));

      categoriesToShow.forEach(item => {
        item.class = getCategoryTextClass(item);
      });

      return categoriesToShow;
    });

    const [lazyCategories] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'id');

    onMounted(async () => {
      allCategories.value = await getCategories({});
    });

    const updatePreviouslySelectedIds = () => {
      if (!lazyValue.value) {
        return;
      }

      previouslySelectedIds.value = [
        ...previouslySelectedIds.value,
        ...(props.multiple ? lazyValue.value : [lazyValue.value]),
      ];
    };

    watch(lazyValue, updatePreviouslySelectedIds, { deep: true });

    useRouter(async () => {
      previouslySelectedIds.value = [];
    });

    const validationName = computed(() => props.label || $i18n.t($lang.content.CATEGORY));

    return {
      lazyValue,
      lazyCategories,
      validationName,
    };
  },
};
</script>
